import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { UserTaskActions } from "redux/actions/UserTaskActions";
import { TableColumn, Table, TableRow, sortType } from "app/components/common/Table";
import { PageContentHeader } from "app/components/common/PageContentHeader";
import Translator from "app/components/common/Translator";

import { StoreModel } from "models/StoreModel";
import { LoginUser } from "models/LoginUser";
import { Translations } from "models/Translations";
import { UserTask } from "models/UserTask";

interface Props {
    fetchUserTasks: typeof UserTaskActions.fetchUserTasks;
    deleteUserTask: typeof UserTaskActions.deleteUserTask;
    loginUser: LoginUser;
    userTasks: UserTask[];
    translations: Translations;
}

class AllTasks extends React.Component<Props> {
    componentDidMount() {
        if (this.loggedIn() && !this.props.userTasks) {
            this.props.fetchUserTasks(this.props.loginUser.token);
        }
    }

    loggedIn() {
        return this.props.loginUser && this.props.loginUser.token;
    }

    ready() {
        return this.loggedIn() && this.props.userTasks;
    }

    setTaskData(): TableRow[] {
        return this.props.userTasks.map(t => {
            const open = UserTask.isOpen(t);
            return {
                dataObject: {
                    id: t.id,
                    machine: t.machine,
                    task: UserTask.description(t),
                    userToDo: t.userToDo,
                    dateTodo: t.dateTodo,
                    userCreated: t.userCreated,
                    dateFinished: t.dateFinished,
                    userFinished: t.userFinished,
                    archivedDate: t.archivedDate
                },
                cells: [
                    { name: "userToDo", sortVal: t.userToDo?.userName ?? '', cell: <>{t.userToDo?.userName}</> },
                    { name: "dateTodo", sortVal: new Date(t.dateTodo).getTime(), cell: <>{new Date(t.dateTodo).toLocaleDateString()}</> },
                    { name: "userCreated", sortVal: t.userCreated?.userName ?? '', cell: <>{t.userCreated?.userName}</> },
                    { name: "dateFinished", sortVal: open ? 0 : new Date(t.dateFinished).getTime(), cell: <>{open ? '' : new Date(t.dateFinished).toLocaleDateString()}</> },
                    { name: "userFinished", sortVal: t.userFinished?.userName ?? '', cell: <>{t.userFinished?.userName}</> },
                ]
            };
        });
    }

    setColumns(): TableColumn[] {
        return [
            { header: 'Id', accessor: 'id' },
            { header: 'Machine', accessor: 'machine' },
            { header: 'Task', accessor: 'task' },
            { header: 'To Do by', accessor: 'userToDo' },
            { header: 'Date To Do', accessor: 'dateTodo' },
            { header: 'Created by', accessor: 'userCreated' },
            { header: 'Date Finished', accessor: 'dateFinished' },
            { header: 'Finished by', accessor: 'userFinished' },
        ];
    }

    render() {
        if (!this.ready()) {
            return (
                <div className="c-page__content">
                    <PageContentHeader text="All Tasks" />
                    <Translator text="Loading" />
                </div>
            )
        }
        return (
            <div className="c-page__content">
                <PageContentHeader text="All Tasks" />
                <div className="c-card">
                    <Table
                        editable={true}
                        deleteAction={this.props.deleteUserTask}
                        columns={this.setColumns()}
                        defaultSort={{ columnId: 'dateTodo', sortType: sortType.desc }}
                        tableData={this.setTaskData()}
                        translations={this.props.translations}
                        loginUser={this.props.loginUser}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        loginUser: state.loginUser,
        userTasks: state.userTasks,
        translations: state.translations
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        fetchUserTasks: bindActionCreators(UserTaskActions.fetchUserTasks, dispatch),
        deleteUserTask: bindActionCreators(UserTaskActions.deleteUserTask, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllTasks);
